import React, { useState, useEffect, useContext, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import {
  GetMethodData,
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";
import "./../LatestNav/LatestNav.css";
import * as XLSX from "xlsx";
//import Pagination from "../../CommonUI/Pagination/Pagination";
// import Pagination from "https://cdn.skypack.dev/rc-pagination@3.1.15";
import execl from "../../../images/excel.png";
// import Pagination from 'rc-pagination';
import { Pagination } from "antd";
import { Vortex } from "react-loader-spinner";
import animation from "../../../images/jm-animation.gif";

function LatestNav() {
  const [data, setData] = useState("");
  const [dataDropFund, setDataDropdownFund] = useState("");
  const [DropdownFundCode, setDataDropdownFundCode] = useState("");
  const [DropdownFundType, setDataDropdownFundType] = useState("");
  const [values, setValues] = useState("Equity");
  const [Valuesdrop, setValuesdrop] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [size, setSize] = useState(perPage);
  const [current, setCurrent] = useState(1);
  const [loadingshow, setloadingshow] = useState(false);
  const [activeTab, setActiveTab] = useState("Equity");
  // alert(Valuesdrop)
  const { BaseURL, BaseURLShare } = useContext(URLstateContext);

  const [selectedOptionFundCode, setSelectedOption] = useState("");
  const [showAdditionalDropdowns, setShowAdditionalDropdowns] = useState(false);
  const [optiondesc, setSelectedOptionOptionDesc] = useState("");
  const [showAdditionalDropdowns2, setShowAdditionalDropdowns2] =
    useState(false);
  const [selectedOptionFundtype, setSelectedOptionFundCode] = useState("");
  const [showAdditionalDropdowns1, setShowAdditionalDropdowns1] =
    useState(false);
  let arrayData = [],
    arrayDataCol = [];
  const handleChangeFundName = (event) => {
    setData("");
    setloadingshow(false);
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns(true);
      setloadingshow(false);
    } else {
      setShowAdditionalDropdowns(false);
      setloadingshow(false);
    }
  };

  const handleChangeFundCode = (event) => {
    setData("");
    setloadingshow(false);
    const selectedValue = event.target.value;
    setSelectedOptionFundCode(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns1(true);
    } else {
      setShowAdditionalDropdowns1(false);
    }
  };

  const handleChangeOptiinDesc = (event) => {
    setData("");
    setloadingshow(false);
    const selectedValue = event.target.value;
    setSelectedOptionOptionDesc(selectedValue);
    if (selectedValue !== "") {
      setShowAdditionalDropdowns2(true);
    } else {
      setShowAdditionalDropdowns2(false);
    }
  };

  let PageSize = size;
  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetNavDetailsInner", {
      type: values,
      IVFundCode: "",
      IVPlanType: "",
      IVSchemeCode: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        // console.log(DecryptAESdata(data.data));
        setloadingshow(false);
        // if(optiondesc != ''){
        //     setData()
        // }
        // console.log(DecryptAESdata(data.data))
      }
      // else {
      //      setData('');
      //     setloadingshow(false);
      // }
    });
  }, [BaseURL, values]);

  const buttonGo = (event) => {
    // alert("Final")
    // event.preventDefault();
    GetPostMethodData(BaseURL + "GetNavDetailsInner", {
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: selectedOptionFundtype,
      IVSchemeCode: optiondesc,
    }).then(
      (data) => {
        if (data.data != null && data.data.length > 0) {
          setData(DecryptAESdata(data.data));
          // setloadingshow(false);
          // console.log(DecryptAESdata(data.data))
        }
      },
      [
        BaseURL.values,
        selectedOptionFundCode,
        selectedOptionFundtype,
        optiondesc,
      ],
    );
  };

  const columns = [
    { label: "Category Name", value: "categoryname" },
    { label: "Scheme Name", value: "scheme_name" },
    { label: "Scheme Code", value: "schemecode" },
    { label: "NAV Date", value: "navdate" },
    { label: "NAV", value: "Nav" },
  ];
  useEffect(() => {
    setSelectedOptionFundCode("");
  }, [selectedOptionFundCode]);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "NAV",
      type: values,
      IVFundCode: "",
      IVPlanType: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFund(DecryptAESdata(data.data));
        setloadingshow(false);
        //console.log(DecryptAESdata(data.data), "drop")
      }
    });
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "NAV",
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFundCode(DecryptAESdata(data.data));
        setloadingshow(false);
        //console.log(DecryptAESdata(data.data), "dropFundcode")
      }
    });
    GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
      IVPage: "NAV",
      type: values,
      IVFundCode: selectedOptionFundCode,
      IVPlanType: selectedOptionFundtype,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropdownFundType(DecryptAESdata(data.data));
        setloadingshow(false);
        // console.log(DecryptAESdata(data.data), "dropFundtype")
      }
      // if(selectedOptionFundtype != ""){
      //     document.getElementsByClassName('btn-go-nav').style.display = "block";
      // }
    });
  }, [BaseURL, values, selectedOptionFundCode, selectedOptionFundtype]);

  const handleChange = (e) => {
    e.preventDefault();
    const valueLi = e.currentTarget.getAttribute("data-value");
    setValues(valueLi);
    setActiveTab(valueLi);
    setValuesdrop("");
    setShowAdditionalDropdowns(false);
    setSelectedOptionOptionDesc("");
    setSelectedOption("");
    // setData('')
  };

  const handleChangeDrop = (e) => {
    // alert()
    // const valueLidrop = e.currentTarget.getAttribute("data-drop")
    // setValuesdrop(valueLidrop)
    // alert(valueLidrop)
  };

  function exportToExcel(data, columns) {
    const dataNew = data.map((item) => {
      const dataItem = {};
      columns.forEach((column) => {
        dataItem[column.label] = item[column.value];
      });
      return dataItem;
    });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dataNew);
    const columnWidths = [
      { wch: 14 },
      { wch: 48 },
      { wch: 14 },
      { wch: 13 },
      { wch: 12 },
    ];
    worksheet["!cols"] = columnWidths;
    const cellNumberFormat = "#,##0.00";
    const cell = XLSX.utils.encode_cell({ r: 0, c: 0 });
    worksheet[cell].z = cellNumberFormat;
    XLSX.utils.book_append_sheet(workbook, worksheet, "LatestNav");
    XLSX.writeFile(workbook, "LatestNav.xlsx");
  }

  const currentTableData = useMemo(() => {
    if (data != null) {
      const firstPageIndex = (current - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      if (data != null) {
        if (data.length > 0) {
          // return data.slice(firstPageIndex, lastPageIndex);
          return data.slice((current - 1) * PageSize, current * PageSize);
        }
      }
    }
  }, [current, data, PageSize]);

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <>
          <i className="fa fa-angle-double-left" />
          <span className="sr-only">Previous page</span>
        </>
      );
    }

    if (type === "next") {
      return (
        <>
          <i className="fa fa-angle-double-right" />
          <span className="sr-only">Next page</span>
        </>
      );
    }

    return originalElement;
  };

  useEffect(() => {
    // Page number items
    document
      .querySelectorAll(".pagination-data .rc-pagination-item")
      .forEach((item) => {
        item.setAttribute("role", "button");
      });

    // Previous button
    document
      .querySelectorAll(".pagination-data .rc-pagination-prev")
      .forEach((item) => {
        item.setAttribute("role", "button");
        item.setAttribute("aria-label", "Previous page");
      });

    // Next button
    document
      .querySelectorAll(".pagination-data .rc-pagination-next")
      .forEach((item) => {
        item.setAttribute("role", "button");
        item.setAttribute("aria-label", "Next page");
      });
  }, [current, data]);

  return (
    <>
      <Container>
        <Row>
          <Col sm={12}>
            <section className="navs-and-dividends-section">
              <div className="container-fluid p-0">
                <div className="tab-content sub-content" id="pills-tabContent">
                  <div
                    className="tab-pane nav-tab fade show active"
                    id="pills-nav"
                    role="tabpanel"
                  >
                    <div className="container">
                      <div
                        className="tab-content sub-content"
                        id="nav-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="pills-latest-nav"
                          role="tabpanel"
                        >
                          {/* <h2>Latest NAV</h2> */}
                          <div className="tile inner-tab" id="">
                            <ul
                              className="nav nav-tabs nav-justified"
                              role="tablist"
                            >
                              {/* <li className="nav-item" data-value="" onClick={(e) => handleChange(e)}>
                                                                <a className="nav-link active" id="equity-schemes-tab" data-toggle="tab"
                                                                    href="#equity-schemes" role="tab" aria-controls="equity-schemes"
                                                                    aria-selected="true">All</a>
                                                            </li> */}

                              <li
                                className="nav-item"
                                data-value="Equity"
                                onClick={(e) => handleChange(e)}
                                role="presentation"
                              >
                                <a
                                  className={`nav-link ${activeTab === "Equity" ? "active" : ""}`}
                                  id="equity-schemes-tab"
                                  data-toggle="tab"
                                  href="#equity-schemes"
                                  role="tab"
                                  aria-selected="true"
                                >
                                  Equity
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                data-value="fixedincome"
                                onClick={(e) => handleChange(e)}
                                role="presentation"
                              >
                                <a
                                  className={`nav-link ${activeTab === "fixedincome" ? "active" : ""}`}
                                  id="arbitrage-schemes-tab"
                                  data-toggle="tab"
                                  href="#arbitrage-schemes"
                                  role="tab"
                                  aria-selected="false"
                                >
                                  Fixed Income
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                data-value="Hybrid"
                                onClick={(e) => handleChange(e)}
                                role="presentation"
                              >
                                <a
                                  className={`nav-link ${activeTab === "Hybrid" ? "active" : ""}`}
                                  id="debt-schemes-tab"
                                  data-toggle="tab"
                                  href="#debt-schemes"
                                  role="tab"
                                  aria-selected="false"
                                >
                                  Hybrid
                                </a>
                              </li>
                            </ul>

                            <div className="tab-content inner-content">
                              <div
                                className="tab-pane latest-nav-tab fade show active"
                                id="equity-schemes"
                                role="tabpanel"
                                aria-labelledby="equity-schemes-tab"
                              >
                                <div className="header-wrapper">
                                  {/* <form action=""> */}
                                  <div className="header-container">
                                    {values !== "" ? (
                                      <>
                                        <div className="form-container">
                                          <label htmlFor="first-dropdown">
                                            Select Fund
                                          </label>

                                          <div className="select-container">
                                            <select
                                              id="first-dropdown"
                                              className="fund-selector"
                                              onChange={handleChangeFundName}
                                              value={selectedOptionFundCode}
                                              autoComplete="off"
                                            >
                                              <option value="">
                                                Please Select Fund
                                              </option>
                                              {dataDropFund &&
                                                dataDropFund.map(
                                                  ({
                                                    schemecode,
                                                    schemename,
                                                  }) => (
                                                    <option value={schemecode}>
                                                      {schemename}
                                                    </option>
                                                  ),
                                                )}
                                            </select>
                                            <i className="fa fa-caret-down"></i>
                                          </div>

                                          {showAdditionalDropdowns && (
                                            <div>
                                              <label htmlFor="second-dropdown">
                                                Select Plan
                                              </label>
                                              <div className="select-container">
                                                <select
                                                  id="second-dropdown"
                                                  className="fund-selector"
                                                  onChange={
                                                    handleChangeFundCode
                                                  }
                                                  value={selectedOptionFundtype}
                                                >
                                                  <option value="">
                                                    Please Select Plan
                                                  </option>
                                                  {DropdownFundCode &&
                                                    DropdownFundCode.map(
                                                      ({ PlanType }) => (
                                                        <option
                                                          value={PlanType}
                                                        >
                                                          {PlanType}
                                                        </option>
                                                      ),
                                                    )}
                                                </select>
                                                <i className="fa fa-caret-down"></i>
                                              </div>
                                              <label htmlFor="third-dropdown">
                                                Select Option
                                              </label>
                                              <div className="select-container">
                                                {selectedOptionFundtype ===
                                                "" ? (
                                                  <select
                                                    id="third-dropdown"
                                                    className="fund-selector"
                                                    onChange={
                                                      handleChangeOptiinDesc
                                                    }
                                                    value={optiondesc}
                                                  >
                                                    <option value="">
                                                      Please Select Option
                                                    </option>
                                                  </select>
                                                ) : (
                                                  <select
                                                    id="third-dropdown"
                                                    className="fund-selector"
                                                    onChange={
                                                      handleChangeOptiinDesc
                                                    }
                                                    value={optiondesc}
                                                  >
                                                    <option value="">
                                                      Please Select Option
                                                    </option>
                                                    {DropdownFundType &&
                                                      DropdownFundType.map(
                                                        ({
                                                          SchemeCode,
                                                          OptionDesc,
                                                        }) => (
                                                          <option
                                                            value={SchemeCode}
                                                          >
                                                            {OptionDesc}
                                                          </option>
                                                        ),
                                                      )}
                                                  </select>
                                                )}

                                                <i className="fa fa-caret-down"></i>
                                              </div>
                                              {/* {optiondesc != "" ? 
            <div className="btn-go-nav">
                <button onClick={buttonGo}>View Nav</button>
            </div> 
            :
             <div></div>} */}
                                              {/* <div className="btn-go-nav">
                <button onClick={buttonGo}>View Nav</button>
            </div> */}
                                            </div>
                                          )}
                                          {optiondesc != "" ? (
                                            <div className="btn-go-nav">
                                              <button onClick={buttonGo}>
                                                VIEW NAV
                                              </button>
                                            </div>
                                          ) : (
                                            <div></div>
                                          )}
                                          {/* <select name="fund" id="fund" className="fund-selector" onChange={(event) => setValuesdrop(event.target.value)}>
        <option value=''>Select Scheme</option>
        {dataDrop && dataDrop.map(
            ({ schemename, Nav, navdate, schemecode }) => (
                <option value={schemecode} >{schemename}</option>
            )
        )}
        {loadingshow ? <div className="textcentervertex"> */}
                                          {/* <Vortex
                visible={true}
                height="80"
                width="80"
                ariaLabel="vortex-loading"
                wrapperStyle={{}}
                wrapperClass="vortex-wrapper"
                colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
            /> */}
                                          {/* <img src={animation} alt="Loading" />
            <div className="model_popup">Please Wait...</div>
        </div> : ""
        }
    </select> */}
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                    {/* <button className="button header-btn" onClick={() => exportToExcel(data)}></button> */}
                                    <div
                                      className="export-excel"
                                      style={{ alignSelf: "right" }}
                                    >
                                      <img
                                        src={execl}
                                        onClick={() =>
                                          exportToExcel(data, columns)
                                        }
                                      ></img>
                                    </div>
                                  </div>
                                  {/* </form> */}
                                </div>
                                <div className="funds-container">
                                  <div className="table-responsive">
                                    <table
                                      className="table"
                                      aria-label="Mutual Fund NAV Details"
                                    >
                                      <caption className="sr-only">
                                        Mutual Fund Scheme NAV Information
                                      </caption>

                                      <thead>
                                        <tr>
                                          <th scope="col">Scheme Name</th>
                                          <th scope="col">NAV Date</th>
                                          <th scope="col">NAV</th>
                                        </tr>
                                      </thead>

                                      {currentTableData === null ? (
                                        <tbody>
                                          <tr>
                                            <td colSpan="3">
                                              <div className="errorMsg">
                                                <h3>No Data Found</h3>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      ) : null}

                                      <tbody>
                                        {currentTableData &&
                                          currentTableData.map(
                                            (
                                              {
                                                scheme_name,
                                                Nav,
                                                navdate,
                                                isin,
                                              },
                                              index,
                                            ) => (
                                              <tr
                                                key={
                                                  index || isin || scheme_name
                                                }
                                              >
                                                <td>{scheme_name}</td>
                                                <td>{navdate}</td>
                                                <td>{Nav}</td>
                                              </tr>
                                            ),
                                          )}

                                        {loadingshow ? (
                                          <tr>
                                            <td
                                              colSpan="3"
                                              className="textcentervertex"
                                            >
                                              <img
                                                src={animation}
                                                alt="Loading"
                                              />
                                              <div className="model_popup">
                                                Please Wait...
                                              </div>
                                            </td>
                                          </tr>
                                        ) : null}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              {currentTableData &&
                                currentTableData.length > 0 && (
                                  <Pagination
                                    align="end"
                                    className="pagination-data"
                                    showTotal={(total, range) =>
                                      `Showing ${range[0]}-${range[1]} of ${total}`
                                    }
                                    onChange={PaginationChange}
                                    total={
                                      data.length != null ? data.length : 0
                                    }
                                    current={current}
                                    pageSize={size}
                                    showTitle={false}
                                    showSizeChanger={false}
                                    itemRender={PrevNextArrow}
                                  />
                                )}

                              {/* {currentTableData == null && (
                                                                <div className="textcentervertex">
                                                                    <img src={animation} alt="Loading" />
                                                                    <div className="model_popup">Please Wait...</div>
                                                                </div>
                                                            )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default LatestNav;
